import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Project, getProjects, createProject, deleteProject } from '../../api/client';

export function ProjectList() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [newName, setNewName] = useState('');
  const [newAddress, setNewAddress] = useState('');

  const loadProjects = async () => {
    if (!token) return;
    try {
      const data = await getProjects(token);
      setProjects(data);
    } catch (error) {
      console.error('Failed to load projects:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProjects();
  }, [token]);

  const handleCreate = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token || !newName.trim()) return;
    try {
      await createProject(token, newName, newAddress || undefined);
      setNewName('');
      setNewAddress('');
      setShowForm(false);
      loadProjects();
    } catch (error) {
      console.error('Failed to create project:', error);
    }
  };

  const handleDelete = async (projectId: number) => {
    if (!token) return;
    if (!window.confirm('Are you sure you want to delete this project?')) return;
    try {
      await deleteProject(token, projectId);
      loadProjects();
    } catch (error) {
      console.error('Failed to delete project:', error);
    }
  };

  if (loading) {
    return <div>Loading projects...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ margin: 0 }}>Projects</h2>
        <button
          onClick={() => setShowForm(!showForm)}
          style={{
            background: '#1a1a2e',
            color: '#fff',
            border: 'none',
            padding: '10px 20px',
            cursor: 'pointer',
            borderRadius: '4px'
          }}
        >
          {showForm ? 'Cancel' : '+ New Project'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} style={{
          background: '#f5f5f5',
          padding: '20px',
          marginBottom: '24px',
          borderRadius: '8px'
        }}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Project Name *</label>
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              placeholder="e.g., Smith Residence"
              style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
              required
            />
          </div>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Address</label>
            <input
              type="text"
              value={newAddress}
              onChange={(e) => setNewAddress(e.target.value)}
              placeholder="e.g., 123 Main St"
              style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
            />
          </div>
          <button
            type="submit"
            style={{
              background: '#28a745',
              color: '#fff',
              border: 'none',
              padding: '10px 20px',
              cursor: 'pointer',
              borderRadius: '4px'
            }}
          >
            Create Project
          </button>
        </form>
      )}

      {projects.length === 0 ? (
        <p style={{ color: '#666' }}>No projects yet. Create your first project!</p>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {projects.map(project => (
            <div
              key={project.id}
              onClick={() => navigate(`/admin/projects/${project.id}`)}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
                e.currentTarget.style.borderColor = '#007bff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#fff';
                e.currentTarget.style.borderColor = '#ddd';
              }}
              style={{
                border: '1px solid #ddd',
                borderRadius: '8px',
                padding: '16px',
                paddingRight: '36px',
                position: 'relative',
                cursor: 'pointer',
                transition: 'background-color 0.15s, border-color 0.15s',
                backgroundColor: '#fff'
              }}
            >
              <h3 style={{ margin: '0 0 8px 0' }}>{project.name}</h3>
              {project.address && <p style={{ margin: 0, color: '#666' }}>{project.address}</p>}
              <p style={{ margin: '8px 0 0 0', color: '#999', fontSize: '14px' }}>
                Created: {new Date(project.created_at).toLocaleDateString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
